import React from 'react';
import { BellRing, BellOff, Telescope } from 'lucide-react';
import { Switch } from '../ui/switch';
import { usePrepAlerts } from '../../lib/useRadarHistory';

const Hint = ({ status }) => {
    if (!status.telegram_linked) {
        return (
            <a
                href="#telegram"
                data-testid="radar-prep-toggle-link-telegram"
                onClick={(e) => {
                    if (window.matchMedia('(max-width: 767px)').matches) {
                        e.preventDefault();
                        window.dispatchEvent(new CustomEvent('cds:navigate', { detail: { section: 'telegram' } }));
                    }
                }}
                className="text-amber-300 underline underline-offset-2 hover:text-amber-200"
            >
                Telegram bağlı değil — önce bağla
            </a>
        );
    }
    if (!status.favorites_count) return <span className="text-amber-300">Favorin yok — coinleri ⭐ ile favorile</span>;
    return <span className="text-slate-400">{status.favorites_count} favori coin izleniyor · Telegram: /radar ac · /radar kapat</span>;
};

export default function RadarPrepToggle() {
    const { status, saving, toggle } = usePrepAlerts();
    if (!status) return null;
    const on = status.enabled;
    const early = status.early_enabled !== false;
    const Icon = on ? BellRing : BellOff;
    return (
        <div data-testid="radar-prep-toggle" className="px-4 py-2 border-b border-slate-700/60 bg-slate-900/60 flex items-center gap-x-3 gap-y-1.5 flex-wrap text-[11px]">
            <Icon className={`h-3.5 w-3.5 ${on ? 'text-emerald-300' : 'text-slate-500'}`} />
            <span className="text-slate-100 font-medium">Favori HAZIRLAN bildirimi</span>
            <Switch
                data-testid="radar-prep-toggle-switch"
                checked={on}
                disabled={saving}
                onCheckedChange={(v) => toggle({ enabled: v })}
                aria-label="Favori HAZIRLAN Telegram bildirimi"
            />
            <span data-testid="radar-prep-toggle-state" className={`font-bold ${on ? 'text-emerald-300' : 'text-slate-500'}`}>{on ? 'AÇIK' : 'KAPALI'}</span>
            <span className="text-slate-600">|</span>
            <Telescope className={`h-3.5 w-3.5 ${early ? 'text-sky-300' : 'text-slate-500'}`} />
            <span className="text-slate-100 font-medium" title="Favori olmayan coinlerde de: ERKEN HAZIRLAN (henüz koşmamış, sert kanıtlı, geçmişi iyi) ve İLK HAREKET (hacim + ilk ivme + OI). Coin başına 4-6 saatte bir, saatte en fazla 3-4 mesaj.">Erken sinyaller (tüm coinler)</span>
            <Switch
                data-testid="radar-early-toggle-switch"
                checked={early}
                disabled={saving}
                onCheckedChange={(v) => toggle({ early: v })}
                aria-label="Erken HAZIRLAN ve İLK HAREKET Telegram bildirimi"
            />
            <span data-testid="radar-early-toggle-state" className={`font-bold ${early ? 'text-sky-300' : 'text-slate-500'}`}>{early ? 'AÇIK' : 'KAPALI'}</span>
            <span className="text-slate-600">|</span>
            <span className="text-slate-100 font-medium" title="Sade: sadece AÇ / KÜÇÜK AÇ / EMİR KOY kararları + kendi pozisyonunun sonuçları. Detaylı: HAZIR OL, hazırlık bozuldu, güçlü alarm, haber dahil her şey.">Telegram modu</span>
            <div className="inline-flex rounded-md border border-slate-600 overflow-hidden" data-testid="tg-mode-toggle">
                {[['sade', 'Sade'], ['detay', 'Detaylı']].map(([k, l]) => (
                    <button key={k} type="button" disabled={saving} onClick={() => toggle({ mode: k })} data-testid={`tg-mode-${k}`}
                            className={`px-2 py-0.5 text-[10px] font-bold ${(status.tg_mode || 'sade') === k ? 'bg-orange-500/20 text-orange-100' : 'text-slate-400 hover:text-slate-200'}`}>
                        {l}
                    </button>
                ))}
            </div>
            <span className="text-[10px]" data-testid="radar-prep-toggle-hint"><Hint status={status} /></span>
            <span className="ml-auto text-[10px] text-slate-500 hidden md:inline">Favori: EMİR KOY, tetik doldu, sahte kırılım · Erken: koşmamış kaliteli kurulumlar + KÜÇÜK AÇ · Telegram: /radar erken ac|kapat · /mod sade|detay</span>
        </div>
    );
}
